const PUBLIC = `${process.env.PUBLIC_URL}`;

export default {
  followUS: `${PUBLIC}/images/gif/followus.gif`,
  avatar: `${PUBLIC}/images/gif/avatar.gif`,
  success: `${PUBLIC}/images/gif/success.gif`,
  verifyEmail: `${PUBLIC}/images/gif/verify-email.gif`,
  backgroundProfile: `${PUBLIC}/images/gif/background.gif`
};
